var _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

const SvgCarotLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.727,
    height: 21.765,
    viewBox: "0 0 12.727 21.765",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.624 21.131) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.253.574a2.1,2.1,0,0,1,2.887,0l7.84,7.73a1.891,1.891,0,0,1,0,2.6,1.739,1.739,0,0,1-2.53,0L10.91,4.522a.434.434,0,0,0-.588,0L2.963,11.145A1.745,1.745,0,0,1,.442,10.97a1.9,1.9,0,0,1,.169-2.61Z",
    transform: "translate(0 0)"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCarotLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Carot_Left.19dfc270.svg";
export { ForwardRef as ReactComponent };